class contextList {
  constructor() {
   this.CreateOrganizationContext=null;
   this.CreateCategoryContext=null;
  }
}

export default (new contextList);
